import React, { useCallback, useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { ArrowBackIcon } from 'icons';
import { Button, IconButton, styled } from 'netline-ui';

import { LicenseFooter, ModuleVersion, useAboutModules } from '../../../Navigation';
import PreferencesPopup, { PreferencesPopupType } from '../PreferencesPopup/PreferencesPopup';

import styles, { mobileAboutDialogClasses } from './MobileAboutDialog.styles';

const MobileAboutDialogRoot = styled('div', { name: mobileAboutDialogClasses.$name })(styles);

const MobileAboutDialog = () => {
  const { t } = useTranslation();
  const { dialogTitle, licenseUrl, structuredModuleVersions: moduleVersions } = useAboutModules(null);
  const popupRef = useRef<PreferencesPopupType>(null);

  const closePopup = useCallback(() => {
    if (popupRef.current?.closePopup) {
      popupRef.current.closePopup();
    }
  }, []);

  const onCopyToClipboardClick = useCallback(
    () => navigator.clipboard.writeText(JSON.stringify(moduleVersions)),
    [moduleVersions],
  );

  return (
    <MobileAboutDialogRoot>
      <PreferencesPopup title={t('menu.about')} ref={popupRef}>
        <div className={mobileAboutDialogClasses.container}>
          <div className={mobileAboutDialogClasses.header} data-testid="MobileAboutDialog-header">
            <IconButton onClick={closePopup} data-testid="MobileAboutDialog-closeIcon">
              <ArrowBackIcon className={mobileAboutDialogClasses.closeIcon} />
            </IconButton>
            <span className={mobileAboutDialogClasses.title} data-testid="MobileAboutDialog-title">
              {t('menu.about')}
            </span>
            <Button onClick={onCopyToClipboardClick} size="small" className={mobileAboutDialogClasses.copyButton}>
              {t('about.copy_all')}
            </Button>
          </div>
          <div className={mobileAboutDialogClasses.content} data-testid="MobileAboutDialog-content">
            <div className={mobileAboutDialogClasses.contentTitle} data-testid="MobileAboutDialog-contentTitle">
              {dialogTitle}
            </div>
            <ModuleVersion moduleVersions={moduleVersions} />
            <LicenseFooter licenseUrl={licenseUrl} />
          </div>
        </div>
      </PreferencesPopup>
    </MobileAboutDialogRoot>
  );
};
export default MobileAboutDialog;
